var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSplashMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 98,
    viewBox: "0 0 99 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M93.4681 17.2859L72.109 1.41916C70.1912 -0.00546837 67.558 0.0362053 65.6433 1.46499C60.0484 5.64002 48.1834 13.9493 38.5246 17.0328C30.0744 19.7305 17.5988 20.2526 11.0101 20.3269C8.43836 20.3559 6.20389 22.1673 5.72265 24.6938L0.718991 50.963C0.303556 53.144 1.51903 55.3073 3.59791 56.0869C5.37805 56.7545 6.55738 58.4562 6.55738 60.3574V76.0911C6.55738 78.8398 8.67908 81.1225 11.4205 81.323L36.4271 83.1528C38.6625 83.3164 40.5471 84.8821 41.1175 87.0497L42.7794 93.3652C43.572 96.377 46.786 98.0284 49.6586 96.8251C56.406 93.9988 67.9724 88.7881 75.4098 83.4262C83.2172 77.7976 92.3091 67.7963 96.9434 62.4472C98.706 60.4129 98.5521 57.3881 96.6488 55.4849L85.8827 44.7187C84.09 42.926 83.8358 40.1078 85.2789 38.0233L94.653 24.483C96.2633 22.157 95.7391 18.973 93.4681 17.2859Z",
    fill: "#E2E4E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplashMark);
export default __webpack_public_path__ + "static/media/splashMark.a06bf9a92208bed96a504a95eed671cc.svg";
export { ForwardRef as ReactComponent };